import React from 'react';

import styles from './RegisterEmailStep.module.scss';
import { useTranslation } from 'react-i18next';
import Button, { ButtonStyles } from 'components/common/Form/Button';
import Input from 'components/common/Form/Input';
import { Link, useParams } from 'react-router-dom';
import Routes from 'constants/Routes';
import { STEPS } from 'components/Auth/Register/Register';
import GoogleAuth from 'components/Auth/GoogleAuth/GoogleAuth';
import FacebookAuth from 'components/Auth/FacebookAuth/FacebookAuth';
import { isRespondent } from 'constants/UserRoles';

const RegisterEmailStep = ({ values, onChangeField, setStep, errors }) => {
    const { t } = useTranslation();
    const params = useParams();
    const { role } = params;
    return (
        <>
            <div className={styles.title}>{t('auth:text.register')}</div>
            {isRespondent(role) && (
                <>
                    <FacebookAuth />
                    <GoogleAuth />
                    <div className={styles.row}>
                        <div className={styles.line} />
                        <div className={styles.or}>{t('common.or')}</div>
                        <div className={styles.line} />
                    </div>
                </>
            )}
            <Input
                placeholder={t('auth:form.email')}
                label={t('auth:form.enterEmail')}
                labelClassName={styles.inputLabel}
                value={values.email}
                name='email'
                onChangeField={onChangeField}
                error={errors.email}
                autoFocus
            />
            <Button
                text={t('common.continue')}
                btnStyle={ButtonStyles.primary}
                className={styles.fullWidth}
                onClick={() => setStep(STEPS.password)}
            />
            <div className={styles.confirmation}>{t('auth:form.confirmation')}</div>
            <div className={styles.loginReminder}>
                {t('auth:text.alreadyHaveAccount')}{' '}
                <Link to={Routes.signIn.path}>
                    <span>{t('auth:text.logIn')}</span>
                </Link>
            </div>
        </>
    );
};

export default RegisterEmailStep;
